/* eslint-disable */
import { useContext } from 'react';

import {
  CAUSED_BY_BACK,
  CAUSED_BY_CORS,
  CAUSED_BY_FRONT,
  CAUSED_BY_TIMEOUT,
  TIME_LIMIT,
  ERROR_CORS,
  URL_AUDITORY,
  MONITORING_FRONTEND_MESSAGE,
  MONITORING_BEFOREPOST_MESSAGE,
} from '../utils/constants';
import {
  dynamicErrorTraceId,
  dynamicGetTraceId,
  getError,
  getLineError,
  getUrlClient,
  getUrlConsume,
  isEmpty,
} from '../utils/functions';
import { Monitoring } from '../utils/monitoring';
import { MESSAGE_CANCEL_REQUEST } from '../../utils/constants/api-constants';
import { logsAuditory, setErrorLog, setSuccessLog } from './actions';
import { AuditoryContext, outAuditory as store } from './feature';

export const outAuditory = store;
export const useAuditory = () => useContext(AuditoryContext);

const readError = (error, dateIni, dateEnd) => {
  const seconds = Math.ceil((dateEnd.getTime() - dateIni.getTime()) / 1000);
  const request = Object.values(error || {});
  const message = request.find(
    (err) => !isEmpty(err) && Boolean(err?.response),
  );
  if (message?.response) {
    return getError(CAUSED_BY_BACK, message.response, getLineError(error));
  }
  const errorMessage = error.message === ERROR_CORS ? CAUSED_BY_CORS : CAUSED_BY_FRONT;
  return getError(
    seconds >= TIME_LIMIT
      ? CAUSED_BY_TIMEOUT
      : errorMessage,
    error.message || String(error),
    getLineError(error),
    Boolean(!error.message),
  );
};

const sendLog = async (request, customSuccess, customError, step = {}) => {
  try {
    const {
      name = 'SOAT',
      operation = 'POST',
      path,
      data,
    } = request;
    if (path.includes(URL_AUDITORY)) {
      return;
    }

    const url = await getUrlConsume(name, path);
    const urlC = await getUrlClient();

    const { dispatch, state } = outAuditory;

    const log = {
      urlCliente: urlC,
      urlServicio: url,
      request: data || '',
      paso: state.step.paso,
      pasoDescripcion: state.step.pasoDescripcion,
      ...step,
    };
    if (!isEmpty(customSuccess)) {
      if (customSuccess?.config) {
        delete customSuccess.config;
      }
      log.respuestaExito =
        operation === 'GET'
          ? customSuccess?.data || customSuccess
          : customSuccess;
      setSuccessLog(dispatch, log);
    }
    if (!isEmpty(customError)) {
      if (customError.error?.isCrash) {
        return logsAuditory(dispatch, state.auditoria, {
          paso: log.paso,
          pasoDescripcion: log.pasoDescripcion,
          urlServicio: '',
          urlCliente: urlC,
          respuestaError: JSON.stringify(customError),
          request: JSON.stringify(log.request),
        });
      }
      log.respuestaError = customError;
      setErrorLog(dispatch, log);
    }
  } catch (e) {}
};

export const withAuditoryAmplify = (ApiConsume) => async (req) => {
  let customSuccess = {};
  let customError = {};
  const { state, selector } = outAuditory;
  const request = Object.assign(req);
  const dateIni = new Date();
  const paso = {
    paso: state.step.paso,
    pasoDescripcion: state.step.pasoDescripcion,
  };
  let traceId = null;

  let actionName = request?.action;
  let actionApi = request?.name || 'SOAT';
  let actionComponent = `${state.step.pasoDescripcion}:${actionName}`;

  const origin = 'withAuditoryAmplify';

  try {
    const { endReport } = Monitoring.startReport({
      origin,
      actionApi,
      actionName,
      actionComponent,
      auditoryId: window.idAuditoria,
      urlClient: window.location.href,
      pathClient: window.location.pathname
    });
    customSuccess = await ApiConsume(req);
    traceId = dynamicGetTraceId(customSuccess);
    endReport(traceId);

    return customSuccess;
  } catch (error) {

    console.error(error);
    console.error("erros withAuditoryAmplify", { error });

    const dateEnd = new Date();
    const errData = error.response?.data;

    traceId = dynamicErrorTraceId(errData);

    if (errData?.response?.status) {
      let e = errData?.response?.status?.error;
      customError = getError(e?.code, e?.messages?.join(', '), getLineError(error));
    } else if (errData) {
      customError =
        typeof errData === 'object'
          ? errData
          : getError(CAUSED_BY_BACK, errData);
    } else {
      customError = readError(error, dateIni, dateEnd);
    }
    customError.selector = selector;
    throw error;
  } finally {
    let actionUrl = '';
    try {
      actionUrl = await getUrlConsume(request.name, request.path);
    } catch (error) {
      console.error(error);
    }

    if (customError?.error?.message !== MESSAGE_CANCEL_REQUEST) {
      Monitoring.reportError({
        origin,
        customError,
        actionApi,
        actionComponent,
        actionName,
        actionUrl,
        auditoryId: window.idAuditoria,
        traceId,
        errorString: JSON.stringify(customError),
        urlClient: window.location.href,
        pathClient: window.location.pathname
      });
      sendLog(request, customSuccess, customError, paso);
    }
  }
};

export const withAuditoryDigitalData = async ({
  code,
  error,
  endpoint = '',
  urlPageError = '',
  params = '',
  urlClient = '',
  pathClient = '',
}) => {
  try {
    let customError = {};
    const { selector, dispatch, state } = outAuditory;

    if (error?.stack) {
      customError = getError(code, error.stack + '', getLineError(error));
    } else if (typeof error === 'object') {
      customError = getError(code, JSON.stringify(error), getLineError(error));
    } else {
      customError = getError(code, error + '', getLineError(error));
    }
    customError.urlRedirectError = urlPageError;
    customError.selector = selector;

    const urlC = await getUrlClient();

    logsAuditory(dispatch, state.auditoria, {
      paso: state.step.paso,
      pasoDescripcion: state.step.pasoDescripcion,
      urlServicio: endpoint,
      urlCliente: urlC,
      respuestaError: JSON.stringify(customError),
      request: params ? JSON.stringify(params) : '',
    });

    if (customError?.error?.message) {
      setErrorLog(dispatch, {
        urlServicio: endpoint,
        urlCliente: urlC,
        respuestaError: customError,
        request: '',
      });
      Monitoring.reportError({
        origin: 'withAuditoryDigitalData',
        customError,
        actionName: 'trackError',
        customMessage: MONITORING_BEFOREPOST_MESSAGE,
        auditoryId: window.idAuditoria,
        errorString: JSON.stringify(customError),
        actionComponent: `${state.step.pasoDescripcion}:trackError`,
        urlClient,
        pathClient
      });
    }
  } catch (err) {
    console.error(err);
  }
};

export const withAuditoryCrashlytics = async ({
  code,
  message,
  stack,
  error,
}) => {
  try {
    const { selector, dispatch, state } = outAuditory;
    const customError = getError(code, message, getLineError(error));
    customError.selector = selector;
    customError.stack = stack;
    const urlC = await getUrlClient();

    logsAuditory(dispatch, state.auditoria, {
      paso: state.step.paso,
      pasoDescripcion: state.step.pasoDescripcion,
      urlServicio: '',
      urlCliente: urlC,
      respuestaError: JSON.stringify(customError),
      request: '',
    });

    Monitoring.reportError({
      origin: 'withAuditoryCrashlytics',
      customError,
      actionName: 'trackError',
      customMessage: MONITORING_FRONTEND_MESSAGE,
      auditoryId: window.idAuditoria,
      errorString: JSON.stringify(customError),
      actionComponent: `${state.step.pasoDescripcion}:trackError`,
      urlClient: window.location.href,
      pathClient: window.location.pathname
    });
  } catch (error) {
      console.error(error);
  }
};

export const withSuccessPayment = async (auditory) => {
  try {
    const { dispatch, state } = outAuditory;
    logsAuditory(dispatch, {
      ...state.auditoria,
      ...auditory,
    }, {
      paso: state.step.paso,
      pasoDescripcion: state.step.pasoDescripcion,
      urlCliente: auditory?.urlCliente ?? window.location.href,
    });
  } catch (error) {
    console.error(error);
  }
};
